<template>
  <div
    v-if="$store.getters.getAssetSelectedNode.id"
    class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-map"
  >
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.map.activation.subject') === $route.params.subject
            && $t('mEditionMenu.map.activation.children.days.subedition') === $route.params.subedition
              ? 'submenu-item-active submenu-item-active-map'
              : '']"
          :to="`/${$t('rPaths.map')}/${this.$route.params.id}/${$t('mEditionMenu.map.activation.subject')}/${$t('mEditionMenu.map.activation.children.days.subedition')}`"
        >
          {{ $t('mEditionMenu.map.activation.children.days.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.map.activation.subject') === $route.params.subject
            && ($t('mEditionMenu.map.activation.children.sendingOfDeliverables.subedition') === $route.params.subedition
              || $t('mEditionMenu.map.activation.children.sendingOfDeliverablesCreate.subedition') === $route.params.subedition
              || $t('mEditionMenu.map.activation.children.sendingOfDeliverablesEdit.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-map'
              : '']"
          :to="`/${$t('rPaths.map')}/${this.$route.params.id}/${$t('mEditionMenu.map.activation.subject')}/${$t('mEditionMenu.map.activation.children.sendingOfDeliverables.subedition')}`"
        >
          {{ $t('mEditionMenu.map.activation.children.sendingOfDeliverables.subText') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapActivationSubMenu'
}
</script>
